import { ContractStatusMapped, IContractProduct } from "@/models/contracts";
import { Component, Mixins } from "vue-property-decorator";
import { IStatus } from "@/models/statuses";
import BillingCyclesStore from "./constants/billingCyclesStore";
import _ from "@/boot/lodash";

@Component
export default class CProdMixin extends Mixins(BillingCyclesStore) {
  // Methods

  public getProductName(cProd: IContractProduct) {
    return _.compact([
      _.get(cProd, "product.name_translated") || _.get(cProd, "product.name"),
      _.get(cProd, "service_identifier")
        ? `(${_.get(cProd, "service_identifier")})`
        : null
    ]).join(" ");
  }

  public getCategoryName(cProd: IContractProduct) {
    return (
      _.get(cProd, "product.category.name_translated") ||
      _.get(cProd, "product.category.name")
    );
  }

  public getProductImageSrc(cProd: IContractProduct) {
    const src = _.get(cProd, "product.image.full_url");
    return src ? `${src}?size=100x100` : null;
  }

  public getProvConfigName(cProd: IContractProduct) {
    return cProd.provision_configuration?.name;
  }

  public getPriceTermSummary(cProd: IContractProduct) {
    if (!cProd.billing_cycle_months)
      return this.$store.getters[`brand/taxAwarePrice`]({
        taxIncPrice: cProd.configuration_total_discounted_amount_formatted,
        taxExcPrice: cProd.configuration_net_amount_discounted_formatted
      });
    return [
      this.$store.getters[`brand/taxAwarePrice`]({
        taxIncPrice: cProd.configuration_total_recurring_amount_formatted,
        taxExcPrice: cProd.configuration_total_recurring_net_amount_formatted
      }),
      this.getBillingCycleName(cProd.billing_cycle_months),
      cProd.product?.post_paid
        ? `(${(this.$t("_.estimated") as string).toLowerCase()})`
        : ""
    ]
      .join(" ")
      .trim();
  }

  public getMappedStatus(status: IStatus) {
    return ContractStatusMapped(status as IStatus);
  }
}
